import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cmsCall, ADMIN_TOKEN_KEY, adminToken } from "@/lib/cms";

/** Aparte inlogpagina voor medewerkers/beheer op /stafflogin. */
const StaffLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [wachtwoord, setWachtwoord] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // Al ingelogd? Direct doorsturen naar het beheer.
  useEffect(() => {
    if (!adminToken()) return;
    cmsCall("GET", "/beheer/me", null, { admin: true })
      .then(() => navigate("/beheer", { replace: true }))
      .catch(() => window.localStorage.removeItem(ADMIN_TOKEN_KEY));
  }, [navigate]);

  const doLogin = async () => {
    if (busy) return;
    setError("");
    setBusy(true);
    try {
      const res = await cmsCall("POST", "/beheer/login", { email: email.trim(), wachtwoord });
      window.localStorage.setItem(ADMIN_TOKEN_KEY, res.token);
      navigate("/beheer", { replace: true });
    } catch (e) {
      setError(e.message || "Inloggen mislukt. Probeer het opnieuw.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16" data-testid="stafflogin-page">
      <h1 className="font-display text-2xl font-semibold">Medewerkers inloggen</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Alleen voor beheerders van NextProduct. Klanten loggen in via de klant-inlogpagina.
      </p>
      <Card className="mt-6 p-6">
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            doLogin();
          }}
        >
          {error && (
            <Alert variant="destructive" data-testid="beheer-error">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div className="space-y-2">
            <Label htmlFor="a-email">E-mailadres</Label>
            <Input
              id="a-email"
              type="email"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="beheer-email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="a-pw">Wachtwoord</Label>
            <Input
              id="a-pw"
              type="password"
              autoComplete="current-password"
              value={wachtwoord}
              onChange={(e) => setWachtwoord(e.target.value)}
              data-testid="beheer-password"
            />
          </div>
          <Button type="submit" className="w-full" disabled={busy || !email || !wachtwoord} data-testid="beheer-login">
            {busy ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Bezig…
              </>
            ) : (
              "Inloggen"
            )}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default StaffLogin;
